import { Card } from './card';

export const StoryTelling = () => {
  const storyItems = [
    {
      number: '01',
      title: 'Show, not tell',
      text: 'Highlight your team, environment, and values in ways photos and text can’t',
    },
    {
      number: '02',
      title: 'Build trust',
      text: 'Feature current clinicians discussing their experiences',
    },
    {
      number: '03',
      title: 'Set expectations',
      text: 'Share day-in-the-life perspectives that clarify role expectations and culture ',
    },
    {
      number: '04',
      title: 'Keep visitors engaged',
      text: 'Video increases time on page and improves message retention ',
    },
  ];

  return (
    <div className="max-w-[1280px] pt-[120px] pb-[80px] lg:mx-auto mx-[20px]">
      <div>
        <h1 className="text-center text-[30px] lg:text-[50px]">
          Video Storytelling: Humanizing Your Employer Brand
        </h1>
        <p className="text-center">
          For many candidates, especially those not actively job-hunting, video
          can be the first true look into your organization. We help create
          everything from short reels to leadership messages and role
          spotlights—ready to integrate into your campaigns or landing pages. 
        </p>
        <p className="text-[#2F72BD] text-[24px] text-center">
          Video helps you: 
        </p>

        <div className="flex flex-wrap justify-center gap-[20px]">
          {storyItems.map((item) => (
            <Card
              background="#F3F9FF"
              number={item.number}
              title={item.title}
              text={item.text}
              minHeight="250px"
            />
          ))}
        </div>
      </div>
    </div>
  );
};
